/**
 * Pulls the first human-readable message out of an error body (`{ status: 'error', error: { field:
 * ['Dit evenement is vol'] } }`).
 */
export default function firstErrorMessage(error: unknown): string | null {
	if (typeof error === 'string') {
		return error.length > 0 ? error : null;
	}
	if (!error || typeof error !== 'object') {
		return null;
	}
	const first = Object.values(error as Record<string, unknown>)[0];
	const message = Array.isArray(first) ? first[0] : first;
	return typeof message === 'string' && message.length > 0 ? message : null;
}
